import { CmsField } from 'netlify-cms-core'
import GitInfo from 'react-git-info/macro'
import { Widgets } from '../components/Widgets/types'

export const GIT_BRANCH = process.env.GATSBY_GIT_BRANCH || GitInfo().branch

export const GATSBY_GITLAB_APP_ID = process.env.GATSBY_GITLAB_APP_ID
export const GATSBY_GITLAB_URL = process.env.GATSBY_GITLAB_URL
export const CAPTCHA_REQUIRED = process.env.GATSBY_ENV === 'production' ? true : false

export const API_URL = process.env.GATSBY_API_URL
export const SITE_URL = process.env.GATSBY_SITE_URL
export const JAZZHR_URL = process.env.JAZZHR_URL
export const JAZZHR_API_URL = process.env.JAZZHR_API_URL

export const RECAPTCHA_KEY = process.env.GATSBY_RECAPTCHA_KEY
export const JAZZHR_KEY = process.env.JAZZHR_KEY

export const ROUTE_PATH = {
  news: {
    name: 'News',
    path: '/news/',
  },
  main: {
    name: 'Main',
    path: '/',
  },
  contacts: {
    name: 'Contacts',
    path: '/aboutUs/contactUs/',
  },
  aboutUs: {
    name: 'About Us',
    path: '/aboutUs/',
  },
  events: {
    name: 'Events',
    path: '/events/',
  },
  vacancies: {
    name: 'Careers',
    path: '/careers/',
  },
  faq: {
    name: 'FAQ',
    path: '/faq/',
  },
  privacyPolicy: {
    name: 'Privacy Policy',
    path: '/privacy-policy/',
  },
  connectWithUs: {
    name: 'Connect With Us',
    path: '/connectWithUs/',
  },
  team: {
    name: 'Team',
    path: '/aboutUs/team/',
  },
  leadership: {
    name: 'Leadership',
    path: '/aboutUs/leadership/',
  },
  teamContactUs: {
    name: 'Contact us',
    path: '/aboutUs/contactUs/',
  },
  whatWeDo: {
    name: 'What we do',
    path: '/whatWeDo/technologies',
  },
  technologies: {
    name: 'Technologies',
    path: '/whatWeDo/technologies',
  },
  industries: {
    name: 'Industries we serve',
    path: '/whatWeDo/industries/',
  },
}

// eslint-disable-next-line no-shadow
export enum Colors {
  WHITE = 'white',
  ORANGE = 'orange',
  ORANGE_DARKER = 'orangeDarker',
  MAIN = 'main',
  YELLOW = 'yellow',
  RED = 'red',
  GREEN = 'green',
  PINK = 'pink',
  BLUE = 'blue',
  BLUE_DARKER = 'blueDarker',
  PURPLE = 'purple',
  PURPLE_DARKER = 'purpleDarker',
  GREY = 'grey',
  GREY_DARKER = 'greyDarker',
}

// eslint-disable-next-line no-shadow
export enum TextColors {
  WHITE = 'white',
  DARK = 'dark',
}

export const SLUG_PATTERN = '^[a-z0-9](?:[a-z0-9-]){0,218}[a-z0-9]$'
export const TAG_PATTERN = '^[a-zA-Z/]+(?:-[/a-zA-Z0-9]+)*$'

export type BackgroundColorType = 'white' | 'grey' | 'dark' | 'greyLight' | 'greyLighter'

type RecordColors = Record<Colors, string>
type RecordTextColors = Record<TextColors, string>

export const ColorsArray = Object.values(Colors)
export const TextColorsArray = Object.values(TextColors)

export type ColorsType = keyof RecordColors
export type TextColorsType = keyof RecordTextColors

export interface IFrontmatter<TFrontmatter> {
  frontmatter: TFrontmatter
}

export interface IGraphQuery<TQuery> {
  data: TQuery
}

export interface IAllMarkdownRemark<TNode> {
  allMarkdownRemark: {
    nodes: TNode[]
  }
}

export interface IMarkdownRemark<TNode> {
  markdownRemark: TNode
}

export type IAllMarkdownRemarkQuery<TNode> = IGraphQuery<IAllMarkdownRemark<TNode>>

export const CMS_CONTENT_FIELD: CmsField = {
  label: 'Content',
  name: 'content',
  widget: 'list',
  types: [
    {
      label: 'Markdown',
      name: Widgets.Markdown,
      widget: 'object',
      fields: [
        {
          label: 'Markdown',
          name: Widgets.Markdown,
          widget: 'object',
          fields: [
            {
              label: 'Body',
              name: 'body',
              widget: 'markdown',
              editor_components: ['code-block'], // image is a separate block
            },
          ],
        },
      ],
    },
    {
      label: 'Image',
      name: Widgets.Image,
      widget: 'object',
      fields: [
        {
          label: 'Image',
          name: Widgets.Image,
          widget: 'object',
          fields: [
            {
              label: 'Image',
              name: 'image',
              widget: 'image',
            },
            {
              label: 'Alt',
              name: 'alt',
              widget: 'string',
              required: false,
            },
          ],
        },
      ],
    },
    {
      label: 'Video',
      name: Widgets.Video,
      widget: 'object',
      fields: [
        {
          label: 'Video',
          name: Widgets.Video,
          widget: 'object',
          fields: [
            {
              label: 'Source',
              name: 'source',
              widget: 'string',
            },
          ],
        },
      ],
    },
    {
      label: 'Embedded Code',
      name: Widgets.EmbeddedCode,
      widget: 'object',
      fields: [
        {
          label: 'Embedded Code',
          name: Widgets.EmbeddedCode,
          widget: 'object',
          fields: [
            {
              label: 'Embedded Code',
              name: 'embeddedCode',
              widget: 'text',
            },
          ],
        },
      ],
    },
  ],
}
